// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-4ef0a45b] {\n  max-height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
